module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.objUserCompanies,
      "label": "Company",
      "item-value": "id",
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.currentUserCompany),
      callback: function($$v) {
        _vm.currentUserCompany = $$v
      },
      expression: "currentUserCompany"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateUserCompany()
      }
    }
  }, [_vm._v("Save")])], 1)])])], 1)], 1)
},staticRenderFns: []}